import React from "react";
import { useLanguage } from "../../contexts/LanguageContext"; // Import the language context
import { translations } from "../../i18n"; // Import translations

const InnerBanner = ({ pageKey }) => {
  const { language } = useLanguage(); // Get the current language
  const pageData = translations[language]?.pages[pageKey]; // Fetch data for the specific page key

  return (
    <>
    {/* <div className="container-fluid bg-primary py-5 inner-banner">
      <div className="row py-5">
        <div className="col-12 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-4 text-white animated zoomIn">
            {pageData || "Page Title"}
          </h1>
        </div>
      </div>
    </div> */}
     <section class="hero-section position-relative overflow-hidden">
    <div class="hero-bg-animation"></div>
    <div class="container-fluid h-100">
      <div class="row h-100 align-items-center justify-content-center text-center">
        <div class="col-12 col-lg-8">
          
          <h1 class="display-3 text-white fw-bold mb-4 animate__animated animate__fadeInDown">
          {pageData || "Page Title"} 
          </h1>
          {/* <p className="text-white">Weaving Digital Innovation<br/>Into the Fabric of Textile Trade</p> */}
          <div class="animate__animated animate__fadeInUp animate__delay-1s">
            {/* <a href="#about-content" class="btn btn-light btn-lg rounded-pill px-4 py-2 mt-3 scroll-down">
              Explore Our Story <i class="bi bi-arrow-down ms-2"></i>
            </a> */}
          </div>
        </div>
      </div>
    </div>
    {/* <div class="hero-curve"></div> */}
  </section>
    </>
  );
};

export default InnerBanner;
